<template>
    <!--START Endorsements-->
        <section class="section pt-4 scroll-select" id="endorsements">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <h1 class="section-title text-center">Participants</h1>
                        <div class="section-title-border margin-t-20"></div>
                        <p class="section-subtitle text-muted text-center font-secondary padding-t-30">
                            These are the groups participating in the protest. The list is updated daily. You can register your participation <a href="#endorse-form">here</a>.
                        </p>
                    </div>
                </div>
                <div class="row margin-t-50">
                    <div v-for="endorsement in endorsements" class="col-lg-3 col-sm-6">
                        <endorsement :name="endorsement.name" :second-name="endorsement.secondName" :image="endorsement.image" :link="endorsement.link"></endorsement>
                    </div>
                </div>
            </div>
        </section>
        <!--END Endorsements-->
</template>

<script>
"use strict";
import Endorsement from "../Elements/Endorsement";
import endorsements_data from "../../data/endorsments.json";

export default {
  name: 'Endorsements',
    components: {Endorsement},
    data() {
      return {
          endorsements: endorsements_data,
      }
    }
}
</script>
